import { Component } from '@angular/core';

@Component({
  selector: 'fv-renderer',
  template: `form builder`,
  styles: [``],
})
export class FBRendererComponent {
  constructor() { }
}
